module.exports = __webpack_public_path__ + "img/search-header-with-nav-mazda.0be77622.png";